import { Modal } from "antd";
import { useEffect, useState } from "react";
import "./feedbackModal.css";
import { FeedbackForm, FeedbackFormCopy } from "../../forms/FeedbackForm/FeedbackForm";

type Props = {
  open: boolean;
  onClose: () => void;

  // optional
  title?: string;
  thanksText?: string;
  submitLabel?: string;
  formCopy?: FeedbackFormCopy;
};

export const FeedbackModal = ({
  open,
  onClose,
  title = "",
  thanksText = "",
  submitLabel = "",
  formCopy,
}: Props) => {
  const [mode, setMode] = useState<"form" | "success">("form");
  const [isModalReady, setIsModalReady] = useState(false);

  useEffect(() => {
    if (!open) {
      setMode("form");
      setIsModalReady(false);
    }
  }, [open]);

  useEffect(() => {
    if (open) setMode("form");
  }, [open]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      destroyOnClose
      maskClosable
      className="oc-feedbackModal"
      afterOpenChange={(opened) => {
        setIsModalReady(opened);
      }}
      closeIcon={<span className="oc-feedbackModal__closeIcon" />}
    >
      {mode === "success" ? (
        <div className="oc-feedbackModal__success">
          <div className="oc-feedbackModal__title">{title}</div>
          <div className="oc-feedbackModal__successIcon" />
          <div className="oc-feedbackModal__successText">{thanksText}</div>
        </div>
      ) : (
        <>
          <div className="oc-feedbackModal__title">{title}</div>

          {isModalReady ? (
            <FeedbackForm
              submitLabel={submitLabel}
              thanksText={thanksText}
              showTender
              copy={formCopy}
              onSuccess={() => setMode("success")}
            />
          ) : null}
        </>
      )}
    </Modal>
  );
};
